import TopBar from '../home/components/TopBar';
import Header from '../home/components/Header';
import AboutSection from '../home/components/AboutSection';
import Footer from '../home/components/Footer';
import FloatingWhatsApp from '../home/components/FloatingWhatsApp';
import ChatPopup from '../home/components/ChatPopup';

const SobreNos = () => {
  return (
    <div className="min-h-screen bg-white">
      <TopBar />
      <Header />
      
      <div className="py-16">
        <AboutSection />
      </div>

      <Footer />
      <FloatingWhatsApp />
      <ChatPopup />
    </div>
  );
};

export default SobreNos;
